module.exports = __webpack_public_path__ + "img/12-preview.118ed9c4.jpg";